import request from '../libs/request';

const res = 'ProcessInst';

export default {
  addMessage(id, message) {
    return request({
      url: `api/${res}/addMessage`,
      method: 'post',
      data: {
        id,
        message
      }
    });
  }
};
